<template>
  <Navbar></Navbar>

  <div id="app-view-mobile" class="mt-3 px-3">
    <router-view v-slot="{ Component, route }">
      <transition name="zoom" mode="out-in">
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>

    <div id="fullscreen-btn">
      <button
        class="btn d-print-none"
        :class="themeIcon == 'dark_mode' ? 'btn-dark' : 'btn-secondary'"
        @click="toggleTheme"
      >
        <i class="material-icons">{{ themeIcon }}</i>
      </button>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import { version } from "../package.json";
import Helper from "./components/Helper.vue";
import Swal from "sweetalert2";
import { processQueue } from "@/utils/rQueue.js";

export default {
  components: {
    Navbar,
  },
  data() {
    return {
      version: version,
      themeIcon: "light_mode",
      notification: [],
      queueInterval: null,
    };
  },
  mounted() {
    console.log(this.version);

    Helper.request.notificationCall.make = true;

    //this.getMyNotifications();

    let current = localStorage.getItem("carclean_theme");
    if (!current) {
      current = "light";
    }

    if (current === "light") {
      document.documentElement.setAttribute("data-bs-theme", "light");
      document.getElementById("app").setAttribute("data-bs-theme", "light");
      localStorage.setItem("carclean_theme", "light");
      this.themeIcon = "dark_mode";
    } else {
      document.getElementById("app").setAttribute("data-bs-theme", "dark");
      document.documentElement.setAttribute("data-bs-theme", "dark");
      localStorage.setItem("carclean_theme", "dark");
      this.themeIcon = "light_mode";
    }

    // Processamento recorrente da fila de requisições
    this.queueInterval = setInterval(() => {
      processQueue();
    }, 5000);
  },
  beforeUnmount() {
    if (this.queueInterval) {
      clearInterval(this.queueInterval);
    }
  },
  methods: {
    getMyNotifications() {
      if (!sessionStorage.getItem("jwt")) {
        return;
      }
      Helper.axiosRequest({
        url: "/notification/mine?unread=1&toast=1&markread=1", // &markread=1
        onSuccess: (res) => {
          this.notification = res.data.list;

          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: true,
          });

          for (let i = 0; i < this.notification.length; i++) {
            let alertIcon = "info";
            if (this.notification[i].priority > 1) {
              if (this.notification[i].priority > 2) {
                alertIcon = "warning";
              }

              Toast.fire({
                icon: alertIcon,
                title: this.notification[i].title,
                html: this.notification[i].body,
              });
            }
          }
        },
      });
    },
    toggleTheme() {
      let current = localStorage.getItem("carclean_theme");
      if (!current) {
        current = "light";
      }

      if (current === "light") {
        // apply darkmode
        document.documentElement.setAttribute("data-bs-theme", "dark");
        document.getElementById("app").setAttribute("data-bs-theme", "dark");
        localStorage.setItem("carclean_theme", "dark");
        this.themeIcon = "light_mode";
      } else {
        // apply lightmode
        document.getElementById("app").setAttribute("data-bs-theme", "light");
        document.documentElement.setAttribute("data-bs-theme", "light");
        localStorage.setItem("carclean_theme", "light");
        this.themeIcon = "dark_mode";
      }
    },
  },
};
</script>

<style>
/* CSS para a transição de slide e fade */
/* .slide-fade-enter-active {
  transition: all 0.1s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(100%);
  opacity: 0;
} */

.zoom-enter-active,
.zoom-leave-active {
  transition: all 0.2s ease;
}
.zoom-enter-from,
.zoom-leave-to {
  transform: scale(0.8);
  opacity: 0;
}

#fullscreen-btn {
  position: fixed;
  bottom: 5px;
  right: 5px !important;
}

.strong {
  font-weight: 600 !important;
}

.material-icons {
  align-items: center !important;
  justify-content: center !important;
}

.inline-icon {
  vertical-align: middle !important;
  font-size: 22px !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.striked {
  text-decoration: line-through !important;
}

/** BAR */
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
